export const setMappingUavos = mappingTable => ({
  type: 'SET_MAPPING_UAVOS',
  payload: mappingTable,
});
